import { render } from "./LoginStep.vue?vue&type=template&id=0708b32e&ts=true"
import script from "./LoginStep.vue?vue&type=script&lang=ts"
export * from "./LoginStep.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__